import { object, string } from "yup";

export const updateOrderErpCustomerModelSchema = object({
    customerCode: string()
        .required("Cari Hesap Kodu zorunludur")
        .max(50, "Cari Hesap Kodu 50 karakterden uzun olamaz"),
    taxCode: string()
        .required("VKN zorunludur.")
        .max(11, "VKN en fazla 11 haneli olabilir.")
        .min(10, "VKN en az 10 haneli olabilir."),
})